<template>
  <div data-test-id="user-reviews">
    <user-review v-for="review in visibleReviews" :key="review.name" class="mb-8" :review="review" />
  </div>
</template>

<script>
import { UserReview } from "@/component-library/user-review"

import i18n from "@/modules/i18n"

const SHOWN_REVIEWS = 4

export default {
  name: "UserReviews",
  components: {
    UserReview
  },
  data() {
    return {
      allReviewsVisible: false
    }
  },
  computed: {
    visibleReviews() {
      const allReviews = this.$t("userReviews.reviews")

      return allReviews.slice(0, SHOWN_REVIEWS)
    }
  },
  i18n: i18n
}
</script>

<style lang="scss">
.fade-reviews-enter-active,
.fade-reviews-leave-active {
  transition: opacity 0.15s;
  transition-timing-function: ease-in;
}

.fade-reviews-enter,
.fade-reviews-leave-to {
  opacity: 0;
}
</style>
